export default __webpack_public_path__ + "static/media/screen2.aa307bb4.png";